<form class="login-form" [formGroup]="form" (submit)="submit()">
  <app-platforms-login></app-platforms-login>

  <mat-form-field appearance="outline">
    <input
      matInput
      [placeholder]=" 'authorization.yourLoginOrEmail' | translate "
      formControlName="username"
    />
    <mat-error *ngIf="formErrorHandler('username', 'required')">{{ 'authorization.yourLoginOrEmail' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <input
      matInput
      formControlName="password"
      [type]="passwordFieldType(isShowPassword)"
      [placeholder]=" 'authorization.yourPassword' | translate "
    />
    <a mat-icon-button matSuffix (click)="changePasswordVisibility()">
      <mat-icon>{{ iconName(isShowPassword) }}</mat-icon>
    </a>
    <mat-error *ngIf="formErrorHandler('password', 'required')">{{ 'authorization.validationErrors.password.required' | translate }}</mat-error>
  </mat-form-field>

  <mat-checkbox formControlName="rememberMe">{{ 'authorization.rememberMe' | translate }}</mat-checkbox>

  <button
    [disabled]="form.invalid"
    type="submit"
    class="login-form__submit"
    mat-flat-button
    color="primary">{{ 'authorization.authorizationButton' | translate }}</button>

  <span class="login-form__miss-pass">{{ 'authorization.forgotPassword' | translate}}</span>
</form>
